// Section.jsx

import React from 'react';

import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './Section.css';

/**
 * Section
 * 
 * A simple wrapper component that provides consistent padding and spacing for its children.
 * It adjusts its layout based on the device type (mobile or desktop) to ensure a responsive design.
 * 
 * @param {string} gap - The gap between child elements (default is '12px').
 * @param {number} padding - The padding of the section (default is 10px).
 * @param {ReactNode} children - The content to be rendered inside the section.
 * 
 * @returns {ReactNode} The rendered component.
 */
const Section = ({ gap = '12px', padding = 10, children }) => {

    const isMobile = useIsMobile();

    // ----- RENDER ----- //

    return (

        <div
          className="section-container"
          style={{
                gap: isMobile ? '5px' : gap,
                //padding: padding,
            }}
        >
            {children}
        </div>

    );
};

// Dev Tools
Section.displayName = 'Section';

export default Section;
